/*
 * Copyright (c) Outright Mental (https://outrightmental.com/) All Rights Reserved.
 */

// vendor
import React from "react";
// app
import "./BoardHeader.scss"
import DashQuantity from "./DashQuantity";
import {
  selectDaysElapsed,
  selectDaysUntilNextCycle,
  selectTotalCycles,
  selectTotalDaysInCycle,
  selectUncapturedMarketShare
} from "../../engine/BoardEngine";
import {useSelector} from "react-redux";
import theme from "../../theme";
import DashProgress from "./DashProgress";

/**
 BoardHeader component renders the game information governing all players
 <p>
 @return {*}
 */
export default function BoardHeader() {

  const
    daysElapsedSelector = selectDaysElapsed(),
    daysElapsed = useSelector(state => daysElapsedSelector(state));

  const
    uncapturedMarketShareSelector = selectUncapturedMarketShare(),
    uncapturedMarketShare = useSelector(state => uncapturedMarketShareSelector(state));

  const
    daysUntilNextCycleSelector = selectDaysUntilNextCycle(),
    daysUntilNextCycle = useSelector(state => daysUntilNextCycleSelector(state));

  const
    totalDaysInCycleSelector = selectTotalDaysInCycle(),
    totalDaysInCycle = useSelector(state => totalDaysInCycleSelector(state));

  const
    totalCyclesSelector = selectTotalCycles(),
    totalCycles = useSelector(state => totalCyclesSelector(state));

  /**
   Render one cycle row

   @param name of this cycle
   @param colorLow HTML color to use for container background
   @param colorHigh HTML color to use for progress bar background
   @param key to use for obtaining statistics from store
   @returns {*}
   */

  function sectionCycleRow(key, colorLow, colorHigh, name) {
    const
      totalDays = totalDaysInCycle[key],
      daysTilNext = daysUntilNextCycle[key];
    return (
      <DashProgress
        backgroundColor={colorLow}
        barBackgroundColor={colorHigh}
        progress={(totalDays - daysTilNext) / totalDays}>
        <span className="stat">{daysTilNext}</span>
        <span className="unit">&nbsp;days</span>
        <span className="unit">&nbsp;until</span>
        <span className="unit">&nbsp;{name}</span>
      </DashProgress>
    );
  }

  return (
    <div className="board-header">
      <div className="sidebar">
        <DashQuantity
          backgroundColor="#434343"
          size={1.6}
          quantity={daysElapsed}
          unit="days"/>
        <DashQuantity
          backgroundColor="#666666"
          size={1}
          quantity={`${uncapturedMarketShare}%`}
          unit="untapped market"/>
      </div>
      <div className="main-panel">
        {sectionCycleRow("expense", theme.pinkLow, theme.pinkHigh, "bills paid")}
        {sectionCycleRow("payroll", theme.purpleLow, theme.purpleHigh, "payroll processing")}
        {sectionCycleRow("market", theme.greenLow, theme.greenHigh, "invoice cycle")}
      </div>
    </div>
  );
};

{/*

      <div className="section">
        {sectionHeader("Resources")}
        {sectionRow("Cash", MONEY.format(playerOneData.resources.cash))}
        {sectionRow("Sales", MONEY.format(playerOneData.resources.salesValue))}
      </div>

      <div className="section">
        {sectionHeader("Departments")}
        {DEPARTMENT_TYPES.map(type => sectionDepartmentTypeRows(type))}
      </div>

      <div className="section">
        {sectionHeader("Cycles")}
        {sectionCycleRow("Payroll", theme.purple, "payroll")}
        {sectionCycleRow("Expense", theme.blue, "expense")}
        {sectionCycleRow("Market", theme.green, "market")}
      </div>
*/
}
